import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';
import DiscrepanciesTable from './Table';

const DiscrepanciesPage = () => {
  return (
    <Content>
      <H1>Проверка расхождений</H1>
      <DiscrepanciesTable />
    </Content>
  );
};

export default DiscrepanciesPage;
